import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useAuth from '../hooks/useAuth';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { paymentRedsysRedirect } from '../services/paymentRedsys';

function PaymenredsysRedirctModal({ showModal, close, invoice_data, embedded = false }) {
  const { t } = useTranslation();
  const { user } = useAuth();

  const [action, setAction] = useState('');
  const [Ds_SignatureVersion, setDs_SignatureVersion] = useState('');
  const [Ds_MerchantParameters, setDs_MerchantParameters] = useState('');
  const [Ds_Signature, setDs_Signature] = useState('');

  const getPaymentRedsys = async () => {
    const response = await paymentRedsysRedirect({
      invoice_id: invoice_data.id,
      odooSid: user.odooSid,
    });
    return response;
  };

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    const response = await getPaymentRedsys();
    setAction(response.url);
    setDs_SignatureVersion(response.Ds_SignatureVersion);
    setDs_MerchantParameters(response.Ds_MerchantParameters);
    setDs_Signature(response.Ds_Signature);
    return ev.target.form.submit();
  };

  const content = (
    <>
      <div className="text-dark pb-2 text-center">
        <strong>{t('invoice')} {invoice_data.name}</strong>
      </div>
      <div className="text-dark pb-2 fw-bold text-center">
        <strong>{t('total-to-pay')} {invoice_data.amount_residual} {invoice_data.currency}</strong>
      </div>

      <form action={action} method="post">
        <input type="hidden" name="Ds_SignatureVersion" value={Ds_SignatureVersion} />
        <input type="hidden" name="Ds_MerchantParameters" value={Ds_MerchantParameters} />
        <input type="hidden" name="Ds_Signature" value={Ds_Signature} />
        <div class="d-flex justify-content-center">
            <Button variant="success" type="button" onClick={handleSubmit}>
              <i className="ri-check-line me-1"></i> {t('pay-redsys')}
            </Button>
        </div>
      </form>

      <div className="text-dark w-100 fs-12 fw-bold text-end mt-3">
        <strong>{t('legal_advertisement')}</strong>
      </div>
    </>
  );

  if (embedded) {
    return content; // usado dentro del nuevo PaymentGatewayModal
  }

  return showModal ? (
    <Modal show={showModal} onHide={close}>
      <Modal.Header closeButton>
        <Modal.Title className="modal-title text-dark text-center">
          {t('confirm-and-pay')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">{content}</Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={close}>
          <i className="ri-close-line me-1"></i> {t('btn-close')}
        </Button>
      </Modal.Footer>
    </Modal>
  ) : null;
}

export default PaymenredsysRedirctModal;
